import { getLocalizedOrDefault } from "../../../helpers/Functions";
import { getImageUrl } from "../../../helpers/PB";

const IndexPageConfig = {
  collection: "index_page",
  single: true,
  fields: [
    "id",
    "promos.promos_id.id",
    "locale.language",
    "locale.languages_code.code",
    "locale.heading",
    "locale.subheading",
    "locale.brand_dropdown_placeholder_text",
    "locale.model_dropdown_placeholder_text",
    "locale.hero_image",
    "locale.nav_divider_text",
    "locale.nav_1_image",
    "locale.nav_1_heading",
    "locale.nav_1_body",
    "locale.nav_1_cta_label",
    "locale.nav_2_image",
    "locale.nav_2_heading",
    "locale.nav_2_body",
    "locale.nav_2_cta_label",
    "locale.nav_3_image",
    "locale.nav_3_heading",
    "locale.nav_3_body",
    "locale.nav_3_cta_label",
    "locale.notes_heading",
    "locale.notes_body",
    "locale.promos_heading"
  ],

  adapter: class IndexPage {
    constructor(settings) {
      this.id = settings.id;

      this.promos = (settings.promos || []).map((ref) => ref.promos_id?.id);

      let locale = settings.locale?.[0];
      this.locale = settings.locale;

      this.heading = locale?.heading;
      this.subheading = locale?.subheading;
      this.brand_dropdown_placeholder_text =
        locale?.brand_dropdown_placeholder_text;
      this.model_dropdown_placeholder_text =
        locale?.model_dropdown_placeholder_text;
      this.hero_image_url = getImageUrl(locale?.hero_image);
      this.nav_1_image_url = getImageUrl(locale?.nav_1_image);
      this.nav_1_heading = locale?.nav_1_heading;
      this.nav_1_body = locale?.nav_1_body;
      this.nav_1_cta_label = locale?.nav_1_cta_label;
      this.nav_2_image_url = getImageUrl(locale?.nav_2_image);
      this.nav_2_heading = locale?.nav_2_heading;
      this.nav_2_body = locale?.nav_2_body;
      this.nav_2_cta_label = locale?.nav_2_cta_label;
      this.nav_3_image_url = getImageUrl(locale?.nav_3_image);
      this.nav_3_heading = locale?.nav_3_heading;
      this.nav_3_body = locale?.nav_3_body;
      this.nav_3_cta_label = locale?.nav_3_cta_label;
      // TODO: Enable this on the backend, or configure it elsewhere
      // - Find by Features
      this.fbf_enabled = true;
      // - Quick Compare
      this.qc_enabled = true;

      this.notes_heading = locale?.notes_heading;
      this.notes_body = locale?.notes_body;
      this.promos_heading = locale?.promos_heading;
    }

    map(collections, maps) {
      this.promos = this.promos.map((id) => maps.promos[id]);
      this.locale = this.locale.map((locale) => {
        const {
          hero_image,
          nav_1_image,
          nav_2_image,
          nav_3_image,
          language,
          languages_code,
          ...other_props
        } = locale;
        return {
          ...other_props,
          language:
            maps.languages?.[languages_code?.code] || maps.locales?.[language],

          hero_image_url: getImageUrl(hero_image),
          nav_1_image_url: getImageUrl(nav_1_image),
          nav_2_image_url: getImageUrl(nav_2_image),
          nav_3_image_url: getImageUrl(nav_3_image)
        };
      });

      const { global_settings } = collections;
      const { default_locale } = global_settings;
      // e.g. field_name: header
      //      selected_locale: 'es-CL'
      this.getLocalized = (field_name, selected_locale) => {
        return getLocalizedOrDefault(
          this,
          field_name,
          { locale: selected_locale },
          { locale: default_locale?.language || default_locale }
        );
      };
    }
  }
};

export default IndexPageConfig;
